/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable eqeqeq */
/* eslint-disable import/order */
import { Grid } from '@material-ui/core'
import React, { useEffect, useRef } from 'react'
import Tabs from '../../../components/hooks/BaseTabs/Tabs'
import Tab from '../../../components/hooks/BaseTabs/Tab'
import {
  mdiBookEditOutline,
  mdiCashMultiple,
  mdiCommentTextMultiple,
  mdiHelpCircleOutline,
  mdiReceiptTextOutline,
} from '@mdi/js'
import PaymentHistory from './PaymentHistory'
import AddonCharges from './AddonCharges'
import Help from './Help'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchPlanDetails,
  fetchBillingProfile,
  fetchSignatureStatus,
  fetchSubscriptionGateway,
} from '../SubscriptionActions'
import { renderRoute, useQueryParams } from '../../../util/utils'
import { Route, useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import CreditCardForm from './Forms/CreditCardForm'
import PlanDetails from './Forms/PlanDetails'
import SubscriptionAlertBanner from './SubscriptionAlertBanner'
import BaseCreatePage from '../../../components/hooks/BaseCreatePage'

const ALERT_BY_STATUS = {
  10: {
    tone: 'info',
    message: 'Complete os dados de pagamento para iniciar sua assinatura.',
  },
  30: {
    tone: 'error',
    message:
      'Fatura com falha no pagamento. Edite o método de pagamento ou tente reprocessar sua fatura, ou ela ficará em débito.',
  },
  40: {
    tone: 'error',
    message: 'Assinatura cancelada. Sem acesso ao sistema até nova contratação',
  },
}

const Subscription = () => {
  const permissions = useSelector(state => state.auth.permissions)
  const planDetails = useSelector(state => state.subscription.planDetails)

  // o max_users do plano muda quando o adicional "Usuário extra" é contratado,
  // ajustado ou cancelado. Todas as actions de addon refazem fetchMyAddons, então
  // observamos a assinatura da lista contratada pra recarregar o subscription-status
  // (fonte do painel "Usuários do plano") apenas quando algo realmente mudou.
  const addonsSignature = useSelector(state =>
    (state.subscription.contractedAddons || [])
      .map(addon => `${addon.id}:${addon.status}:${addon.quantity}`)
      .join('|')
  )

  const history = useHistory()
  const location = useLocation()
  const query = useQueryParams(location.search)
  const value = Number(query.tab) || 0

  const setValue = newValue => {
    history.replace(
      `${location.pathname}?${queryString.stringify({
        ...query,
        tab: newValue,
      })}`
    )
  }

  const dispatch = useDispatch()
  const skipFirstAddonsSync = useRef(true)

  useEffect(() => {
    dispatch(fetchPlanDetails())
    dispatch(fetchSubscriptionGateway())
    dispatch(fetchBillingProfile())
    dispatch(fetchSignatureStatus())
  }, [value])

  useEffect(() => {
    if (skipFirstAddonsSync.current) {
      skipFirstAddonsSync.current = false
      return
    }
    dispatch(fetchSignatureStatus())
  }, [addonsSignature])

  const alert = ALERT_BY_STATUS[planDetails?.status?.var_id]

  return (
    <BaseCreatePage
      page="Lavanderia"
      path="Minha Assinatura"
      goBack
      hiddenReturn
    >
      <Grid item xs={12}>
        <Grid container spacing={2}>
          {alert && (
            <Grid item xs={12}>
              <SubscriptionAlertBanner
                tone={alert.tone}
                message={alert.message}
                actionLabel={alert.actionLabel}
                onAction={() => setValue(0)}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <Tabs>
              <Tab
                label="Plano"
                icon={mdiBookEditOutline}
                value={value}
                setValue={setValue}
                tabIndex={0}
                removeNavigation={false}
              />
              <Tab
                label="Faturas"
                icon={mdiReceiptTextOutline}
                value={value}
                setValue={setValue}
                tabIndex={1}
                removeNavigation={false}
              />
              <Tab
                label="Cobranças Avulsas"
                icon={mdiCashMultiple}
                value={value}
                setValue={setValue}
                tabIndex={2}
                removeNavigation={false}
              />
              <Tab
                label="Ajuda"
                icon={mdiHelpCircleOutline}
                value={value}
                setValue={setValue}
                tabIndex={3}
                removeNavigation={false}
              />
            </Tabs>
          </Grid>

          {value == 0 && (
            <Grid item xs={12}>
              <PlanDetails />
            </Grid>
          )}

          {value == 1 && (
            <Grid item xs={12}>
              <PaymentHistory />
            </Grid>
          )}

          {value == 2 && (
            <Grid item xs={12}>
              <AddonCharges />
            </Grid>
          )}

          {value == 3 && (
            <Grid item xs={12}>
              <Help />
            </Grid>
          )}

          {renderRoute(['gerency-update-laundry-client'], permissions) && (
            <Route
              path="/subscription/credit-card/new"
              component={CreditCardForm}
            />
          )}

          {renderRoute(['gerency-update-laundry-client'], permissions) && (
            <Route
              path="/subscription/credit-card/:id"
              component={CreditCardForm}
            />
          )}
        </Grid>
      </Grid>
    </BaseCreatePage>
  )
}

export default Subscription
